import { render, staticRenderFns } from "./PromotoolsTabs.vue?vue&type=template&id=ad032cb0&scoped=true"
import script from "./PromotoolsTabs.vue?vue&type=script&lang=js"
export * from "./PromotoolsTabs.vue?vue&type=script&lang=js"
import style0 from "./PromotoolsTabs.vue?vue&type=style&index=0&id=ad032cb0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad032cb0",
  null
  
)

export default component.exports